import {
  ADMIN_CERTIFICATES_SETTINGS_NUMBER_FIELDS,
  AdminCertificatesSettingsEditableField,
  AdminCertificatesSettingsNumberField,
} from "../../../../models/admin-certificates-settings.models";

export function isNumberField(
  field: AdminCertificatesSettingsEditableField,
): field is AdminCertificatesSettingsNumberField {
  return ADMIN_CERTIFICATES_SETTINGS_NUMBER_FIELDS.some((numberField) => numberField === field);
}
